<template>
  <div class="tcla-link-table">
    <!-- Top 10 quick view -->
    <div class="tcla-panel">
      <h3 class="tcla-panel__title">🏆 ۱۰ صفحه‌ی برتر از نظر لینک ورودی</h3>
      <div v-if="top10.length === 0" class="tcla-empty">داده‌ای نیست</div>
      <div v-for="(row, idx) in top10" :key="row.url" class="tcla-top-row">
        <span class="tcla-top-row__rank">{{ idx + 1 }}</span>
        <span class="tcla-top-row__title">{{ row.title }}</span>
        <span class="tcla-count-pill tcla-count-pill--in">{{ row.incomingCount }} ورودی</span>
        <span class="tcla-count-pill tcla-count-pill--out">{{ row.outgoingCount }} خروجی</span>
        <button class="tcla-btn" @click="$emit('edit-blog', row.source)">ویرایش</button>
      </div>
    </div>

    <!-- Full sortable table -->
    <div class="tcla-panel">
      <div class="tcla-table-head">
        <h3 class="tcla-panel__title">📋 جدول کامل لینک‌دهی همه‌ی صفحات</h3>
        <input v-model="searchQuery" type="text" placeholder="جستجوی عنوان..." class="tcla-search-input">
      </div>

      <div class="tcla-table">
        <div class="tcla-table__row tcla-table__row--head">
          <span class="tcla-col-title">صفحه</span>
          <span class="tcla-col-count tcla-sortable" @click="setSort('incoming')">
            لینک ورودی {{ sortBy === 'incoming' ? (sortDir === 'desc' ? '↓' : '↑') : '' }}
          </span>
          <span class="tcla-col-count tcla-sortable" @click="setSort('outgoing')">
            لینک خروجی {{ sortBy === 'outgoing' ? (sortDir === 'desc' ? '↓' : '↑') : '' }}
          </span>
          <span class="tcla-col-action"></span>
        </div>

        <div v-for="row in visibleRows" :key="row.url" class="tcla-row-wrapper">
          <div class="tcla-table__row" @click="toggleExpand(row.url)">
            <span class="tcla-col-title">
              <span class="tcla-expand-icon">{{ expanded[row.url] ? '▼' : '◀' }}</span>
              {{ row.title }}
            </span>
            <span class="tcla-col-count">
              <span class="tcla-count-pill tcla-count-pill--in">{{ row.incomingCount }}</span>
            </span>
            <span class="tcla-col-count">
              <span class="tcla-count-pill tcla-count-pill--out">{{ row.outgoingCount }}</span>
            </span>
            <span class="tcla-col-action">
              <button class="tcla-btn" @click.stop="$emit('edit-blog', row.source)">ویرایش</button>
            </span>
          </div>

          <div v-if="expanded[row.url]" class="tcla-detail-row">
            <div class="tcla-detail-col">
              <div class="tcla-detail-col__title">لینک‌های ورودی ({{ row.incomingLinks.length }})</div>
              <div v-if="row.incomingLinks.length === 0" class="tcla-detail-empty">ندارد</div>
              <div v-for="(l, i) in row.incomingLinks" :key="i" class="tcla-detail-item">
                {{ titleOf(l.url) }} <span class="tcla-detail-anchor">«{{ l.anchorText }}»</span>
              </div>
            </div>
            <div class="tcla-detail-col">
              <div class="tcla-detail-col__title">لینک‌های خروجی ({{ row.outgoingLinks.length }})</div>
              <div v-if="row.outgoingLinks.length === 0" class="tcla-detail-empty">ندارد</div>
              <div v-for="(l, i) in row.outgoingLinks" :key="i" class="tcla-detail-item">
                {{ titleOf(l.url) }} <span class="tcla-detail-anchor">«{{ l.anchorText }}»</span>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div v-if="filteredRows.length > visibleRows.length" class="tcla-load-more">
        <button class="tcla-btn tcla-btn--link" @click="showCount += 50">
          نمایش {{ Math.min(50, filteredRows.length - visibleRows.length) }} مورد بعدی
          ({{ visibleRows.length }} از {{ filteredRows.length }})
        </button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'TCLALinkTable',
  props: {
    graph: { type: Object, default: () => ({ nodes: {} }) }
  },
  data() {
    return {
      sortBy: 'incoming',
      sortDir: 'desc',
      searchQuery: '',
      expanded: {},
      showCount: 50
    };
  },
  computed: {
    allRows() {
      return Object.values(this.graph.nodes).map(n => ({
        url: n.url,
        title: n.title,
        source: n.source,
        incomingCount: n.incomingLinks.length,
        outgoingCount: n.outgoingLinks.length,
        incomingLinks: n.incomingLinks,
        outgoingLinks: n.outgoingLinks
      }));
    },
    top10() {
      return [...this.allRows].sort((a, b) => b.incomingCount - a.incomingCount).slice(0, 10);
    },
    filteredRows() {
      const q = this.searchQuery.trim().toLowerCase();
      const rows = q ? this.allRows.filter(r => r.title.toLowerCase().includes(q)) : this.allRows;
      const key = this.sortBy === 'incoming' ? 'incomingCount' : 'outgoingCount';
      const dir = this.sortDir === 'desc' ? -1 : 1;
      return [...rows].sort((a, b) => (a[key] - b[key]) * dir);
    },
    visibleRows() {
      return this.filteredRows.slice(0, this.showCount);
    }
  },
  methods: {
    setSort(key) {
      if (this.sortBy === key) {
        this.sortDir = this.sortDir === 'desc' ? 'asc' : 'desc';
      } else {
        this.sortBy = key;
        this.sortDir = 'desc';
      }
    },
    toggleExpand(url) {
      this.expanded = { ...this.expanded, [url]: !this.expanded[url] };
    },
    titleOf(url) {
      return this.graph.nodes[url] ? this.graph.nodes[url].title : url;
    }
  }
};
</script>

<style scoped>
.tcla-panel {
  background: #fff;
  border: 1px solid #e5e7eb;
  border-radius: 0.75rem;
  padding: 20px;
  margin-bottom: 16px;
}
.tcla-panel__title { font-size: 0.92rem; font-weight: 700; margin: 0 0 12px 0; }
.tcla-empty { text-align: center; padding: 20px; color: #9ca3af; }

.tcla-top-row {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 9px 4px;
  border-bottom: 1px solid #f3f4f6;
}
.tcla-top-row__rank {
  flex-shrink: 0;
  width: 22px;
  height: 22px;
  border-radius: 50%;
  background: #3b82f6;
  color: #fff;
  font-size: 0.7rem;
  font-weight: 700;
  display: flex;
  align-items: center;
  justify-content: center;
}
.tcla-top-row__title {
  flex: 1;
  font-size: 0.84rem;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.tcla-table-head {
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  gap: 10px;
  margin-bottom: 10px;
}
.tcla-search-input {
  padding: 7px 12px;
  border: 1px solid #d1d5db;
  border-radius: 0.375rem;
  font-size: 0.8rem;
  font-family: inherit;
  min-width: 220px;
}

.tcla-table { font-size: 0.82rem; }
.tcla-table__row {
  display: grid;
  grid-template-columns: 3fr 1fr 1fr 0.8fr;
  gap: 10px;
  align-items: center;
  padding: 9px 6px;
  border-bottom: 1px solid #f3f4f6;
  cursor: pointer;
}
.tcla-table__row:hover { background: #f9fafb; }
.tcla-table__row--head {
  font-weight: 700;
  color: #9ca3af;
  font-size: 0.72rem;
  cursor: default;
}
.tcla-table__row--head:hover { background: transparent; }

.tcla-col-title { display: flex; align-items: center; gap: 6px; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }
.tcla-expand-icon { font-size: 0.6rem; color: #9ca3af; flex-shrink: 0; }
.tcla-col-count { text-align: center; }
.tcla-sortable { cursor: pointer; user-select: none; }
.tcla-sortable:hover { color: #3b82f6; }
.tcla-col-action { text-align: left; }

.tcla-count-pill {
  display: inline-block;
  padding: 2px 10px;
  border-radius: 100px;
  font-weight: 700;
  font-size: 0.75rem;
}
.tcla-count-pill--in { background: #d1fae5; color: #16a34a; }
.tcla-count-pill--out { background: #dbeafe; color: #3b82f6; }

.tcla-detail-row {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 16px;
  padding: 12px 20px;
  background: #f9fafb;
  border-bottom: 1px solid #f3f4f6;
  font-size: 0.76rem;
}
.tcla-detail-col__title { font-weight: 700; color: #6b7280; margin-bottom: 6px; }
.tcla-detail-item { padding: 3px 0; color: #374151; }
.tcla-detail-anchor { color: #9ca3af; }
.tcla-detail-empty { color: #9ca3af; }

.tcla-load-more { text-align: center; margin-top: 12px; }

.tcla-btn {
  padding: 6px 12px;
  background: #fff;
  border: 1px solid #d1d5db;
  border-radius: 0.375rem;
  font-size: 0.76rem;
  cursor: pointer;
}
.tcla-btn:hover { background: #f3f4f6; }
.tcla-btn--link { background: transparent; border: none; color: #3b82f6; }
.tcla-btn--link:hover { text-decoration: underline; background: transparent; }
</style>
